import { PropsWithChildren, useState } from 'react';
import { AuthContext } from '@/context/AuthContext';
import { useEntityConfig } from '@/hooks/useEntityConfig';
import { type EnhancedClientSummaryResponse } from '@/types/Auth';

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const [token, setToken] = useState<string | undefined>(undefined);
  const [client, setClient] = useState<EnhancedClientSummaryResponse | undefined>(undefined);
  const [onboardingModalOpen, setOnboardingModalOpen] = useState<boolean>(true);
  const config = useEntityConfig();
  const isAuthenticated = !!token;

  const maskLogin = (login: number | null) => {
    if (login === null || login === undefined) return '';

    if (!config.VITE_ACCOUNT_MASK) return login.toString();

    return '*' + login.toString().slice(-5);
  };

  return (
    <AuthContext.Provider
      value={{
        token,
        setToken,
        isAuthenticated,
        client,
        setClient,
        onboardingModalOpen,
        setOnboardingModalOpen,
        maskLogin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
